<template>
    <div class="dashboard">
        <div class="health">
            <div class="item" style="width: 25%">
                <div class="con" ref="notice2">
                    <div ref="notice" :class="{notice: true, nodata: notice.length == 0}" :style="{height: `${noticeH}px`}">
                        <div v-if="notice.length > 0" class="notice-inner" :style="{ transform: 'translateY(' + currentNoticeOffset + 'px)' }">
                            <p v-for="(item, index) in notice" :key="index"><i class="el-icon-warning-outline" :style="{color: item.iconColor}"></i><span><b>{{item.title}}报警：</b><br>{{item.content}}</span></p>
                        </div>
                        <p v-else>暂无报警</p>
                    </div>
                    <!-- <div v-else class="notice nodata">
                        <p>暂无报警</p>
                    </div> -->
                </div>
            </div>
            <div class="item" style="width: 45%">
                <div class="con">
                    <dash-line-chart title="健康指数分析图" :chart-data="healthyIndexData.data" :min="healthyIndexData.min" :max="healthyIndexData.max" />
                </div>
            </div>
            <div class="item" style="width: 30%">
                <div class="con">
                    <div ref="buildings" class="buildings">
                        <div class="top">
                            <div v-for="(item, key, index) in buildings" :key="index" :class="{active: currBuildingIndex == index}" @click="toBuilding(index)">{{key}}</div>
                        </div>
                        <div class="building-con">
                            <div ref="buildingCon" class="building-con-inner" :style="{ transform: 'translateX(' + currentBuildingOffset + 'px)' }">
                                <div class="building-con-item" v-for="(item, key, index) in buildings" :key="index">
                                    <div class="gauge" :style="{height: `${gaugeHeight}px`}">
                                        <div>
                                            <dash-gauge-chart :title="healthyIndexData.title" :chart-data="item[healthyIndexData.key]" :min="0" :max="healthyIndexData.max" :color="healthyIndexData.gaugeColor" />
                                        </div>
                                        <div v-for="(eItem, index) in envIndexData" :key="index">
                                            <dash-gauge-chart :title="eItem.title" :chart-data="item[eItem.key]" :min="0" :max="eItem.max" :unit="eItem.unit" :size="eItem.size" :color="eItem.gaugeColor" />
                                        </div>
                                    </div>
                                    <div class="devices">
                                        <div v-for="(dItem, dIndex) in item.devices" :key="dIndex">
                                            <i :style="{color: (dItem.status===1 || dItem.status===3)?'green':'red'}" class="el-icon-s-opportunity"></i>
                                            <span>{{dItem.custom_name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="env">
            <div class="item" v-for="(item, index) in envIndexData" :key="index">
                <div class="con">
                    <dash-line-chart :title="item.title+'分析图'" :chart-data="item.data" :min="item.min" :max="item.max" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { Message } from 'element-ui'
import { getHenneryHealthyIndexApi, getHenneryEnvIndexApi, getHenneryInfo, getDevicesApi, getDeviceState, getBuildingLatestHealthyIndexApi } from '@/api/user'
import moment from '@/libs/moment'
import DashLineChart from '@/components/charts/DashLineChart.vue'
// import DashPieChart from '../components/charts/DashPieChart.vue'
import DashGaugeChart from '../components/charts/DashGaugeChart.vue'

export default {
    name: 'Dashboard',
    components: {
        DashLineChart,
        // DashPieChart,
        DashGaugeChart
    },
    data () {
        return {
            currNoticeIndex: 0, // 当前项的索引
            intervalId: null, // 存储定时器ID
            noticeItemHeight: 64, // 每个项的高度
            // buildingItemWidth: '',
            currBuildingIndex: 0,
            buildingItemWidth: 0,
            // currentBuildingOffset: null,
            currHenneryId: Number(this.$route.params.id),
            currHenneryInfo: '',
            oneDayTime: 24 * 60 * 60 * 1000,
            timer: null,
            noticeH: null,
            gaugeHeight: null,
            devices: {},
            buildings: {},
            buildingsMarker: [],
            deviceState: [],
            notice: [
                // {
                //     title: '健康指数',
                //     content: '设备 001 健康指数为59，低于阈值',
                //     iconColor: '#DE912E'
                // },
            ],
            healthyIndexData: {
                key: 'health',
                title: '昨日健康指数',
                min: 0,
                max: 100,
                size: 16,
                data: {
                    xData: [],
                    yData: []
                },
                currValuekey: 'healthy_index',
                threshKey: 'healthy_index',
                iconColor: '#EF5459',
                gaugeColor: '#80FFA5'
            },
            envIndexData: [
                {
                    key: 'temperature',
                    title: '温度',
                    unit: '℃',
                    min: 15,
                    max: 40,
                    size: 16,
                    data: {
                        xData: [],
                        yData: []
                    },
                    currValuekey: 'env_temp',
                    threshKey: 'temp',
                    iconColor: '#DE912E',
                    gaugeColor: '#00DDFF'
                },
                {
                    key: 'air_index',
                    title: '空气质量',
                    min: 0,
                    max: 100,
                    size: 16,
                    data: {
                        xData: [],
                        yData: []
                    },
                    currValuekey: 'air_index',
                    threshKey: 'api',
                    iconColor: '#DE912E',
                    gaugeColor: '#37A2FF'
                },
                {
                    key: 'humidity',
                    title: '湿度',
                    unit: '%',
                    min: 0,
                    max: 100,
                    size: 16,
                    data: {
                        xData: [],
                        yData: []
                    },
                    currValuekey: 'env_humidity',
                    threshKey: 'humidity',
                    iconColor: '#DE912E',
                    gaugeColor: '#FF0087'
                },
                {
                    key: 'pressure',
                    title: '大气压强',
                    unit: 'hPa', // hPa
                    min: 900,
                    max: 1030,
                    size: 16,
                    data: {
                        xData: [],
                        yData: []
                    },
                    currValuekey: 'env_pressure',
                    title: '大气压强',
                    threshKey: 'pressure',
                    iconColor: '#DE912E',
                    gaugeColor: '#FFBF00'
                }
            ],
            // typeData: [
            //   { value: 1048, name: 'Search Engine' },
            //   { value: 735, name: 'Direct' },
            //   { value: 580, name: 'Email' },
            //   { value: 484, name: 'Union Ads' },
            //   { value: 300, name: 'Video Ads' }
            // ]
        }
    },
    methods: {
        getHenneryInfo () {
            getHenneryInfo(this.currHenneryId).then(res => {
                const data = res.data.data
                this.currHenneryInfo = data
                this.getDeviceState()
            })
        },
        lineItem (name, data) {
            return {
                name: name,
                type: 'line',
                data: data,
                connectNulls: true,
                // symbol: 'none',
                showSymbol: false
            }
        },
        getBuildingLatestHealthyIndexData () {
            getBuildingLatestHealthyIndexApi({
                hennery_id: this.currHenneryId
            }).then(res => {
                let data = res.data.data
                data.building_healthy_index.forEach(item => {
                    this.buildings[item.name].health = item.healthy_index[0]
                })
            })
        },
        getHealthyIndexData (now) {
            const end_time = now, start_time = now - this.oneDayTime
            getHenneryHealthyIndexApi({
                start_time,
                end_time,
                hennery_id: this.currHenneryId
            }).then(res=>{
                let data = res.data.data
                if(data.building_healthy_index && data.building_healthy_index.length > 0) {
                    let xData = [], yData = []
                    let healthyIndexData = data.building_healthy_index.sort((a, b) => a.name.localeCompare(b.name))
                    let emptyData = []
                    for(let i=start_time; i<end_time; i+=60*60*1000) {
                        // xData.push(moment(i).format('YYYY-MM-DD HH:mm'))
                        xData.push(moment(i).format('HH:mm'))
                        emptyData.push(0)
                    }
                    healthyIndexData.forEach(bl => {
                        if(bl.healthy_index.length>0) {
                            yData.push(this.lineItem(bl.name, bl.healthy_index))
                            // this.buildings[bl.name].health = bl.healthy_index[bl.healthy_index.length-2]
                        } else {
                            yData.push(this.lineItem(bl.name, emptyData))
                        }
                    })
                    this.healthyIndexData.data = {
                        xData,
                        yData
                    }
                }
            })
        },
        getEnvIndexData (now) {
            const end_time = now, start_time = now - (6 * 60 * 60 * 1000)
            getHenneryEnvIndexApi({
                start_time,
                end_time,
                hennery_id: this.currHenneryId
            }).then(res=>{
                let data = res.data.data
                // console.log('buildings', this.buildings)
                if(data.building_env && data.building_env.length > 0) {
                    let indexData = data.building_env.sort((a, b) => a.name.localeCompare(b.name))
                    this.envIndexData.forEach(item => {
                        let xData = [], yData = []
                        indexData.forEach(bl => {
                            yData.push(this.lineItem(bl.name, bl[item.key]))
                            this.buildings[bl.name][item.key] = bl[item.key][bl[item.key].length - 1]
                        })
                        for(let i=start_time; i<end_time; i+=10*60*1000) {
                            // xData.push(moment(i).format('YYYY-MM-DD HH:mm'))
                            xData.push(moment(i).format('HH:mm'))
                        }
                        item.data = {
                            xData,
                            yData
                        }
                    })
                }
                // console.log('this.buildingsaaa', this.buildings)
                this.startCarousel()
            })
        },
        getDevices (cb) {
            getDevicesApi({
                skip: 0,
                limit: 100,
                // status: 0,
                hennery_id: this.currHenneryId
            }).then(res=>{
                let data = res.data.data.devices ? res.data.data.devices : []
                data = data.sort((a, b) => a.custom_name.localeCompare(b.custom_name))
                data = data.sort((a, b) => a.building_name.localeCompare(b.building_name))
                // console.log('devices', data)
                this.buildingsMarker = []
                this.buildings = {}
                data.forEach((item) => {
                    if(!this.buildingsMarker.includes(item.building_name)) {
                        this.buildingsMarker.push(item.building_name)
                        this.buildings[item.building_name] = {}
                        this.envIndexData.forEach(ei => {
                            this.buildings[item.building_name][ei.key] = null
                        })
                        this.buildings[item.building_name].devices = []
                        this.buildings[item.building_name].devices.push(item)
                    } else {
                        this.buildings[item.building_name].devices.push(item)
                    }
                })
                cb()
                // console.log(this.buildingsMarker, this.buildings)
            })
        },
        getDeviceState () {
            getDeviceState(this.currHenneryId).then(res => {
                const data = res.data.data
                this.deviceState = data
                // console.log('getDeviceState', data)
                this.notice = [
                    // {
                    //     key: 'health',
                    //     title: '健康指数',
                    //     content: '设备 001 健康指数为59，低于阈值'
                    // },
                ]
                data.forEach(item => {
                    this.addNotice(this.healthyIndexData.title, this.healthyIndexData.iconColor, this.healthyIndexData.threshKey, this.healthyIndexData.currValuekey, item)
                    this.envIndexData.forEach(envItem => {
                        this.addNotice(envItem.title, envItem.iconColor, envItem.threshKey, envItem.currValuekey, item)
                    })
                })
            })
        },
        addNotice (title, iconColor, threshKey, currValuekey, item) {
            const min = this.currHenneryInfo[`${threshKey}_min_thresh`], max = this.currHenneryInfo[`${threshKey}_max_thresh`]
            if(min != -100 && item[currValuekey] != null && item[currValuekey] < min) {
                this.notice.push({
                    title,
                    content: `设备 ${item.device_custom_name} ${title}为 ${item[currValuekey]} ，低于阈值`,
                    iconColor
                })
            }
            if(max != -100 && item[currValuekey] != null && item[currValuekey] > max) {
                this.notice.push({
                    title,
                    content: `设备 ${item.device_custom_name} ${title}为 ${item[currValuekey]} ，高于阈值`,
                    iconColor
                })
            }
        },
        getData () {
            const nowTime = new Date().getTime(), tenMinutesTime = 10*60*1000, hourSurplus = nowTime%(6*tenMinutesTime), tenMinutesSurplus = nowTime%tenMinutesTime
            const endTime1 = nowTime - hourSurplus + (6*tenMinutesTime)
            const endTime2 = nowTime - tenMinutesSurplus + tenMinutesTime
            this.getDevices(() => {
                this.getHealthyIndexData(endTime1)
                this.getEnvIndexData(endTime2)
                this.getBuildingLatestHealthyIndexData()
            })
            this.getHenneryInfo()
        },
        nextNotice() {
            // const noticeH = this.$refs.notice.offsetHeight
            // console.log('this.$refs.notice.offsetHeight', this.$refs.notice.offsetHeight)
            // this.noticeH = Math.floor(noticeH/this.noticeItemHeight) * this.noticeItemHeight
            // // const noticeH = this.$refs.notice.offsetHeight
            // console.log('noticeH', Math.floor(this.noticeH/this.noticeItemHeight))
            // this.stopCarousel();
            const skip = this.noticeH/this.noticeItemHeight
            const surplus = this.notice.length - this.currNoticeIndex
            if(surplus >= skip) {
                this.currNoticeIndex = (this.currNoticeIndex + skip) % this.notice.length;
            } else {
                this.currNoticeIndex = (this.currNoticeIndex + surplus) % this.notice.length;
            }
            // this.currNoticeIndex = (this.currNoticeIndex + num) % this.notice.length;
            // console.log('currNoticeIndex', this.currNoticeIndex)
            // this.$nextTick(() => {
            //     this.startCarousel()
            // })
        },
        prevNotice() {
            // this.stopCarousel();
            this.currNoticeIndex = (this.currNoticeIndex - 1 + this.notice.length) % this.notice.length;
            // this.$nextTick(() => {
            //     this.startCarousel();
            // });
        },
        // startNotice() {
        //     this.intervalId = setInterval(this.nextNotice, 5000);
        // },
        // stopNotice() {
        //     if (this.intervalId) {
        //         clearInterval(this.intervalId);
        //         this.intervalId = null;
        //     }
        // },
        nextBuilding() {
            this.currBuildingIndex = (this.currBuildingIndex + 1) % this.buildingsMarker.length
            // console.log('this.currBuildingIndex', this.currBuildingIndex)
            // this.$nextTick(() => {
            //     this.startCarousel()
            // })
        },
        prevBuilding() {
            // this.stopBuilding();
            this.currBuildingIndex = (this.currBuildingIndex - 1 + this.buildingsMarker.length) % this.buildingsMarker.length;
            // this.$nextTick(() => {
            //     this.startCarousel();
            // });
        },
        toBuilding(index) {
            this.currBuildingIndex = index
        },
        startCarousel() {
            this.intervalId = setInterval(() => {
                if(this.notice.length > 0) {
                    this.nextNotice()
                }
                this.nextBuilding()
            }, 5000);
        },
        stopCarousel() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        handleResize () {
            const noticeH = this.$refs.notice2.offsetHeight - 20
            this.noticeH = Math.floor(noticeH/this.noticeItemHeight) * this.noticeItemHeight
            const buildingsWidth = this.$refs.buildings.offsetWidth
            if(buildingsWidth > 500) {
                this.gaugeHeight = Math.floor(buildingsWidth / 5)
            } else {
                this.gaugeHeight = 100
            }
            this.buildingItemWidth = this.$refs.buildingCon.offsetWidth
            if(this.buildingItemWidth <= 480) {
                this.envIndexData[3].size = 10
            } else {
                this.envIndexData[3].size = 16
            }
        }
    },
    created () {
        // console.log(window.innerWidth, window.innerHeight)
        this.$store.commit('setCurrHenneryId', this.$route.params.id)
        setTimeout(() => {
            this.getData()
        }, 10)
        this.timer = setInterval(() => {
                this.getData()
        }, 600000) // 10分钟请求一次
        window.addEventListener('resize', this.handleResize)
    },
    computed: {
        currentNoticeOffset() {
            return this.currNoticeIndex * -this.noticeItemHeight;
        },
        currentBuildingOffset() {
            // console.log('buildingCon', this.$refs.buildingCon)
            return this.currBuildingIndex * -this.buildingItemWidth
        }
        // noticeH() {
        //     return this.$refs.notice.offsetHeight
        // }
    },
    mounted() {
        this.handleResize()
    },
    beforeDestroy () {
        clearInterval(this.timer)
        clearInterval(this.intervalId)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/styles/config.scss';
.dashboard {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 100px 5px 5px;
    display: flex;
    flex-direction: column;
    color: #6ab8ff;
    .health {
        // padding: 10px;
        // flex: 1;
        width: 100%;
        height: 45%;
        flex-shrink: 0;
        display: flex;
        .item {
            width: 25%;
            height: 100%;
            padding: 5px;
            .notice {
                width: 100%;
                height: 100%;
                padding: 5px;
                overflow: hidden;
                .notice-inner {
                    display: flex;
                    flex-direction: column;
                    // transition: transform 0.3s ease;
                    @include rounded(transition, transform .3s ease);
                }
                p {
                    color: #6ab8ff;
                    display: flex;
                    padding: 10px 0px;
                    i {
                        font-size: 44px;
                        margin-right: 10px;
                        &.notice-health {
                            color: #EF5459;
                        }
                        &.notice-env {
                            color: #DE912E;
                        }
                    }
                    span {
                        font-size: 16px;
                        b {
                            // padding-bottom: 5px;
                            // display: inline-block;
                        }
                    }
                }
                &.nodata {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    p {
                        color: #477eb1;
                    }
                }
            }
        }
    }
    .con {
        width: 100%;
        height: 100%;
        background-color: #182760;
        padding: 10px;
        display: flex;
        align-items: center;
        .chart {
            width: 100%;
            height: 100%;
            // padding-top: 50px;
        }
    }
    .env {
        // flex: 1;
        width: 100%;
        height: 55%;
        flex-shrink: 0;
        // background-color: #fff;
        display: flex;
        flex-wrap: wrap;
        .item {
            width: 50%;
            height: 50%;
            padding: 5px;
            // flex: 0 0 50%;
            flex-shrink: 0;
        }
        .item2 {
            width: 40%;
            // height: 100%;
            // padding: 5px;
            flex-shrink: 0;
            // display: flex;
            // flex-wrap: wrap;
            & > div {
                width: 100%;
                height: 50%;
                // flex-shrink: 0;
                padding: 5px;
            }
        }
        .item3 {
            width: 20%;
            height: 100%;
            padding: 5px;
            flex-shrink: 0;
        }
    }
}

.buildings {
    width: 100%;
    height: 100%;
    // padding: 10px;
    display: flex;
    flex-direction: column;
    .top {
        display: flex;
        justify-content: center;
        padding-bottom: 10px;
        &>div {
            padding: 0 10px;
            color: #477eb1;
            cursor: pointer;
            &.active {
                font-weight: bold;
                color: #6ab8ff;
            }
        }
    }
    .building-con {
        flex: 1;
        overflow: hidden;
        padding: 5px 10px 10px 10px;
        .building-con-inner {
            display: flex;
            flex-direction: row;
            height: 100%;
            // transition: transform 0.3s ease;
            @include rounded(transition, transform .3s ease);
            .building-con-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                flex-shrink: 0;
                .gauge {
                    width: 100%;
                    // flex: 1;
                    // height: 100px;
                    height: auto;
                    // background-color: #6ab8ff;
                    display: flex;
                    &>div {
                        flex: 1;
                        padding: 10px;
                    }
                }
                .devices {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    // flex-shrink: 0;
                    flex: 1;
                    &>div {
                        width: 20%;
                        flex-shrink: 0;
                        text-align: center;
                        padding: 5px;
                        display: flex;
                        flex-direction: column;
                        i {
                            font-size: 28px;
                            // padding: 5px;
                        }
                        span {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
}
</style>